import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { useTheme } from "../context/ThemeContext";

const BarChartCard = ({ growthData = [] }) => {
  const { isDarkMode } = useTheme();

  const chartData =
    growthData.length > 0
      ? growthData.map((item) => {
          const date = new Date(item._id);
          const monthName = date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          });

          return {
            name: monthName,
            value: item.count || 0,
            fullDate: item._id,
          };
        })
      : [
          { name: "Jan 1", value: 62 },
          { name: "Jan 5", value: 66 },
          { name: "Jan 10", value: 73 },
          { name: "Jan 15", value: 73 },
          { name: "Jan 20", value: 89 },
          { name: "Jan 25", value: 100 },
          { name: "Jan 28", value: 50 },
          { name: "Feb 1", value: 40 },
          { name: "Feb 5", value: 30 },
        ];

  const maxValue = Math.max(...chartData.map((d) => d.value));

  const mainBackgroundColor = isDarkMode ? "bg-black" : "bg-white";
  const cardBorderColor = isDarkMode ? "border-[#222]" : "border-gray-200";
  const headerTextColor = isDarkMode ? "text-white" : "text-gray-900";
  const subTextColor = isDarkMode ? "text-gray-400" : "text-gray-500";
  const accentColor = "#E87F2C";
  const barFillColor = isDarkMode ? "#222" : "#E5E7EB";
  const axisColor = isDarkMode ? "#888" : "#A1A1AA";
  const tooltipBgColor = isDarkMode ? "bg-black" : "bg-white";
  const tooltipBorderColor = isDarkMode ? "border-zinc-700" : "border-gray-300";
  const tooltipValueColor = isDarkMode ? "text-white" : "text-gray-900";

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className={`${tooltipBgColor} ${tooltipBorderColor} border rounded-lg p-3 shadow-lg`}
        >
          <p className={`${subTextColor} text-xs mb-1`}>
            {payload[0].payload.name}
          </p>
          <p className={`${tooltipValueColor} font-semibold`}>
            New Users:{" "}
            <span style={{ color: accentColor }}>{payload[0].value}</span>
          </p>
        </div>
      );
    }
    return null;
  };
  // --- END LOGIC ---

  // --- THEME-DEPENDENT RENDERING ---
  return (
    <div className={mainBackgroundColor}>
      <div
        className={`${mainBackgroundColor} border ${cardBorderColor} rounded-xl p-5 shadow-lg`}
      >
        <div className="flex justify-between items-center mb-5">
          <h3 className={`text-lg font-medium ${headerTextColor}`}>
            User Growth (Last 30 Days)
          </h3>
          <div className={`${subTextColor} text-sm`}>
            Total New Users:{" "}
            <span style={{ color: accentColor }} className="font-semibold">
              {chartData.reduce((sum, item) => sum + item.value, 0)}
            </span>
          </div>
        </div>

        <ResponsiveContainer width="100%" height={250}>
          <BarChart
            data={chartData}
            margin={{ top: 5, right: 20, left: -10, bottom: 5 }}
          >
            <XAxis
              dataKey="name"
              stroke={axisColor}
              tickLine={false}
              axisLine={false}
              angle={-45}
              textAnchor="end"
              height={60}
              interval="preserveStartEnd"
              tick={{ fill: axisColor, fontSize: 12 }} // Apply color to ticks
            />
            <YAxis
              stroke={axisColor}
              tickLine={false}
              axisLine={false}
              tick={{ fill: axisColor, fontSize: 12 }} // Apply color to ticks
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="value" radius={[4, 4, 0, 0]}>
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={entry.value === maxValue ? accentColor : barFillColor}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>

        {growthData.length === 0 && (
          <p className={`${subTextColor} text-center text-sm mt-2`}>
            No growth data available - showing sample data
          </p>
        )}
      </div>
    </div>
  );
};

export default BarChartCard;
